var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChecklistIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.62533 15.8516L1.66699 12.8932L2.83366 11.7266L4.60449 13.4974L8.14616 9.95573L9.31283 11.1432L4.62533 15.8516ZM4.62533 9.1849L1.66699 6.22656L2.83366 5.0599L4.60449 6.83073L8.14616 3.28906L9.31283 4.47656L4.62533 9.1849ZM10.8337 14.1849V12.5182H18.3337V14.1849H10.8337ZM10.8337 7.51823V5.85156H18.3337V7.51823H10.8337Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecklistIcon2);
export default __webpack_public_path__ + "static/media/checklist-icon (2).b7aaf72da8b65a15fd80adf93082b83b.svg";
export { ForwardRef as ReactComponent };